import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { WebEngage, GA } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import Carousel from "../../atoms/carousel";
import { fetchAllCandidatesList } from "../../../api";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import win from "../../../../assets/images/win.gif";
import lose from "../../../../assets/images/lose.png";
import leading from "../../../../assets/images/leading.gif";
import back from "../../../../assets/images/back.png";
import { VikatanAsidebar } from "../../rows/ad-free";

const CandidateResultPage = ({ data }) => {
  const [candidatesList, setCandidatesList] = useState([]);
  const [team, setTeam] = useState(null);
  useEffect(() => {
    fetchAllCandidatesList()
      .then(res => {
        const resData = get(res, ["data", "items"]);
        setCandidatesList(resData);
      })
      .catch(console.error);
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.CONSTITUENCY_RESULT_PAGE, { collection: data.collection });
  }, []);

  const dataArr =
    candidatesList !== 0 &&
    candidatesList.map(item => {
      return [item.team_id, item];
    }); // creates array of array
  const maparr = new Map(dataArr); // create key value pair from array of array

  const teamList = [...maparr.values()];

  function handleChangeTeam(e) {
    setTeam(e);
  }

  const slidesWithCandidates =
    candidatesList !== 0 &&
    candidatesList.filter(i => (team ? team === i.team_id : i.election_result !== "")).map((slide, idx) => {
      let icon = null;
      if (slide.election_result === "பின்னடைவு") {
        icon = back;
      }

      if (slide.election_result === "முன்னிலை") {
        icon = leading;
      }

      if (slide.election_result === "வெற்றி") {
        icon = win;
      }

      if (slide.election_result === "தோல்வி") {
        icon = lose;
      }
      return (
        <div className={styles["box-div"]} key={"slide-" + idx}>
          <div className={styles["title"]}>
            <h1>{slide.team_name}</h1>
          </div>
          <div className={styles["other-img"]}>
            {slide.star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
            <img src={`${slide.candidate_image}`} className={styles["mem-img"]} />
          </div>
          <h1>
            {slide.candidate_name} <span>({slide.party_name})</span>
          </h1>
          <div className={styles["result-img"]}>
            {icon && <img alt="Vikatan" src={assetify(icon)} className={styles["result"]} />}
          </div>
        </div>
      );
    });

  const teamSliader =
    teamList !== 0 &&
    teamList.map((slide, idx) => {
      return (
        <div
          key={"dslide-" + idx}
          className={`${styles["teamslider"]} ${team === slide.team_id && styles["active"]}`}
          onClick={() => handleChangeTeam(slide.team_id)}
        >
          {slide.team_name}
        </div>
      );
    });

  const vetpalarkalOption = candidatesList.length !== 0 && (
    <div className={styles["other-members-wrapper"]}>
      <h2>நட்சத்திர வேட்பாளர்கள்</h2>

      {teamList !== 0 && (
        <Carousel
          className={`${styles["other-members-slider"]}`}
          options={{
            autoplay: false,
            type: "carousel",
            perView: 4.5,
            gap: 10,
            breakpoints: {
              320: {
                perView: 2.5,
                gap: 10
              },
              767: {
                perView: 2.5,
                gap: 10
              },
              991: {
                perView: 4,
                gap: 10
              }
            }
          }}
          renderCenterLeftControls={({ previousSlide }) => {
            return null;
          }}
          renderCenterRightControls={({ nextSlide }) => {
            return null;
          }}
          renderBottomCenterControls={({ currentSlide, goToSlide }) => {
            return null;
          }}
        >
          {teamSliader}
        </Carousel>
      )}
      <div className={styles["other-members-slider"]}>{slidesWithCandidates}</div>
    </div>
  );

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <ul className={styles["breadcrumb-wrapper"]}>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/">
                    முகப்பு
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/tamil-nadu-election-candidates-result-list-2021">
                    நட்சத்திர வேட்பாளர்கள் பட்டியல்
                  </Link>
                </li>
              </ul>
              {vetpalarkalOption}
            </div>

            <aside className={styles.sidebar}>
              <VikatanAsidebar />
            </aside>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};
export { CandidateResultPage };

CandidateResultPage.propTypes = {
  data: PropTypes.shape()
};
